/**
 * Placeholder terms of service. This is a reasonable starting draft, not
 * reviewed legal copy — replace before it needs to hold up to scrutiny.
 */
export function Terms() {
  return (
    <>
      <section className="page-header">
        <h1>Terms of service</h1>
        <p className="muted">Last updated August 27, 2026.</p>
      </section>

      <article className="panel legal">
        <p>
          These terms cover use of Big Bear Backup — the desktop application and this
          website. By creating an account or installing the app, you agree to them.
        </p>

        <h2>The service</h2>
        <p>
          Big Bear Backup is a client that encrypts and backs up files from your
          Windows 11 machine to a vault you configure. We provide the
          software and, for signed-in accounts, a dashboard that shows the status of
          your backup jobs.
        </p>

        <h2>Your account</h2>
        <p>
          You're responsible for keeping your account credentials and your backup
          passphrase secure. We cannot recover a lost backup passphrase — it is never
          transmitted to us, and without it, encrypted backup data cannot be restored.
          Losing it means losing access to that data, not just to your account.
        </p>

        <h2>Your data</h2>
        <p>
          You keep ownership of everything you back up. Encrypted backup data goes to
          the vault you configure, and you're responsible for that
          location's availability, cost, and any provider's terms that apply to it.
        </p>

        <h2>Acceptable use</h2>
        <p>
          Use the service for backing up your own data, or data you have the right to
          back up. Don't use it to store or transmit unlawful content, attempt to
          disrupt the service, or attempt to access accounts or data that aren't yours.
        </p>

        <h2>No warranty</h2>
        <p>
          The service is provided as-is. We work to keep backups reliable, but we don't
          guarantee the service will be uninterrupted or error-free, and we recommend
          verifying restores periodically rather than trusting any single backup
          unconditionally.
        </p>

        <h2>Limitation of liability</h2>
        <p>
          To the extent permitted by law, we aren't liable for indirect, incidental, or
          consequential damages arising from use of the service, including data loss —
          which is also why the service supports keeping more than one backup.
        </p>

        <h2>Changes</h2>
        <p>
          We may update these terms as the service changes. Continuing to use the
          service after an update means you accept the revised terms.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about these terms can be sent to{" "}
          <a href="mailto:legal@bigbearbackup.com">legal@bigbearbackup.com</a>.
        </p>
      </article>
    </>
  );
}
